export default __webpack_public_path__ + "static/media/four.ff6702f2.png";